import React from 'react';
import {FormattedMessage} from 'react-intl';
import './FullScreenButton.css';
import Icon from 'components/Icon';

export default ({onClick}) => {
  return (
    <a className="FullScreenButton" onClick={onClick}>
      <Icon
        className="FullScreenButton__FullScreenIcon"
        icon={Icon.OPTIONS.EXPAND}
        size={Icon.SIZES.MICRO}
      />
      <FormattedMessage
        id="FullScreenButton__view-full-screen"
        defaultMessage="View Full Screen"
        description="Link to view the domo app fullscreen"
      />
    </a>
  );
};
